import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import Locator from '../../../../../../shared/Locator';
import * as PackageInventoryStore from '../../../../../redux/packageInventory';
import Remediation from '../../../../shared/vulns/Drawer/Remediation';

type Props = {
  version: string;
  packageRevisionLocator: string;
};

/**
 * Container component for the VulnerabilityDrawerHeader
 */
const PackageVersionVulnerabilityDrawerRemediation: VoidFunctionComponent<Props> = ({
  version,
  packageRevisionLocator,
}) => {
  const locator = new Locator(packageRevisionLocator);
  const { isLoading } = useSelector(PackageInventoryStore.selectors.getAsyncStatusGetSelectedVuln);
  const { completeFix, completeFixDistance, partialFix, partialFixDistance } = useSelector(
    PackageInventoryStore.selectors.getSelectedVulnRemediation,
  );

  return (
    <Remediation
      version={version}
      isLoading={isLoading}
      completeFix={completeFix}
      completeFixDistance={completeFixDistance}
      partialFix={partialFix}
      partialFixDistance={partialFixDistance}
      // Technically, user-defined dependencies won't make it this far because we don't have vuln calculations for them.
      // I am leaving this here in case we change that in the future.
      isUserDefinedDependency={locator.isUserDefined()}
    />
  );
};

export default PackageVersionVulnerabilityDrawerRemediation;
